<template>
  <div class="services-page">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Page Header -->
    <section class="page-header">
      <div class="header-bg-pattern"></div>
      <div class="header-gradient"></div>
      <div class="container">
        <div class="row align-items-center min-vh-50 py-5">
          <div class="col-lg-7 text-white position-relative z-2">
            <nav aria-label="breadcrumb" class="mb-4">
              <ol class="breadcrumb breadcrumb-light">
                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Services</li>
              </ol>
            </nav>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">
              Healthcare Services
            </h1>
            <p class="lead mb-4 animate-on-scroll">
              Discover the comprehensive range of healthcare services covered by PONA HEALTH-X.
              From primary care to emergency treatment, we've got your health needs covered.
            </p>
            <div class="header-features d-flex flex-wrap gap-3 animate-on-scroll">
              <div class="header-feature">
                <i class="bx bx-check-circle"></i>
                <span>Outpatient Care</span>
              </div>
              <div class="header-feature">
                <i class="bx bx-check-circle"></i>
                <span>Inpatient Services</span>
              </div>
              <div class="header-feature">
                <i class="bx bx-check-circle"></i>
                <span>Emergency Care</span>
              </div>
              <div class="header-feature">
                <i class="bx bx-check-circle"></i>
                <span>Maternity Services</span>
              </div>
            </div>
          </div>
          <div class="col-lg-5 position-relative z-2 d-none d-lg-block animate-on-scroll">
            <div class="header-image-stack">
              <div class="stack-item stack-1">
                <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=300" alt="Healthcare">
              </div>
              <div class="stack-item stack-2">
                <img src="https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=300" alt="Medical">
              </div>
              <div class="stack-item stack-3">
                <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=300" alt="Hospital">
              </div>
              <div class="stack-badge">
                <span class="badge-number">8+</span>
                <span class="badge-text">Service Categories</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Overview -->
    <section class="py-5 bg-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-info-circle"></i></span>
              <span class="label-text">Overview</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              Comprehensive
              <span class="text-gradient">Healthcare Coverage</span>
            </h2>
            <p class="lead text-muted mb-4">
              PONA HEALTH-X provides access to a wide range of essential healthcare services at contracted
              facilities across the country. Our coverage is designed to meet the healthcare needs of
              every family member.
            </p>
            <div class="overview-stats">
              <div class="stat-item">
                <div class="stat-circle">
                  <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" class="bg-circle"/>
                    <circle cx="50" cy="50" r="45" class="progress-circle" style="stroke-dashoffset: 28"/>
                  </svg>
                  <span class="stat-value">90%</span>
                </div>
                <span class="stat-label">Services Covered</span>
              </div>
              <div class="stat-item">
                <div class="stat-circle">
                  <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" class="bg-circle"/>
                    <circle cx="50" cy="50" r="45" class="progress-circle" style="stroke-dashoffset: 0"/>
                  </svg>
                  <span class="stat-value">100%</span>
                </div>
                <span class="stat-label">Emergency Coverage</span>
              </div>
            </div>
          </div>
          <div class="col-lg-7 animate-on-scroll">
            <div class="services-preview-grid">
              <div class="preview-card" v-for="preview in servicesPreview" :key="preview.title">
                <div class="preview-icon" :style="{ background: preview.gradient }">
                  <i :class="preview.icon"></i>
                </div>
                <div class="preview-content">
                  <h6 class="fw-bold mb-1">{{ preview.title }}</h6>
                  <p class="text-muted small mb-0">{{ preview.count }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Main Services Section -->
    <section class="py-5 bg-light" id="all-services">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-first-aid"></i></span>
            <span class="label-text">Our Services</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Healthcare Services Covered</h2>
          <p class="lead text-muted">Complete list of services available to PONA HEALTH-X members</p>
        </div>

        <!-- Service Categories -->
        <div class="services-accordion">
          <div class="service-category animate-on-scroll"
               v-for="(category, index) in serviceCategories"
               :key="category.title"
               :class="{ 'active': activeCategory === index }"
               @click="toggleCategory(index)">
            <div class="category-header">
              <div class="category-icon" :style="{ background: category.gradient }">
                <i :class="category.icon"></i>
              </div>
              <div class="category-info">
                <h4 class="fw-bold mb-1">{{ category.title }}</h4>
                <p class="text-muted mb-0">{{ category.description }}</p>
              </div>
              <div class="category-meta">
                <span class="service-count">{{ category.services.length }} Services</span>
                <i class="bx bx-chevron-down toggle-icon"></i>
              </div>
            </div>
            <div class="category-body" v-show="activeCategory === index">
              <div class="services-grid">
                <div class="service-item" v-for="service in category.services" :key="service.name">
                  <i class="bx bx-check-circle text-success"></i>
                  <div class="service-details">
                    <span class="service-name">{{ service.name }}</span>
                    <span class="service-note" v-if="service.note">{{ service.note }}</span>
                  </div>
                </div>
              </div>
              <div class="category-footer" v-if="category.note">
                <i class="bx bx-info-circle"></i>
                <span>{{ category.note }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Level Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-layer"></i></span>
            <span class="label-text">Service Levels</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Healthcare Facility Levels</h2>
          <p class="lead text-muted">Understanding the different levels of care in the health system</p>
        </div>

        <div class="facility-levels">
          <div class="level-card animate-on-scroll" v-for="(level, index) in facilityLevels" :key="level.title">
            <div class="level-number">{{ index + 1 }}</div>
            <div class="level-icon" :class="'bg-' + level.color">
              <i :class="level.icon"></i>
            </div>
            <h4 class="fw-bold mb-2">{{ level.title }}</h4>
            <p class="text-muted mb-3">{{ level.description }}</p>
            <ul class="level-services">
              <li v-for="service in level.services" :key="service">
                <i class="bx bx-check"></i>{{ service }}
              </li>
            </ul>
            <div class="level-stats">
              <div class="level-stat">
                <span class="stat-num">{{ level.count }}</span>
                <span class="stat-text">Facilities</span>
              </div>
              <div class="level-stat">
                <span class="stat-num">{{ level.coverage }}</span>
                <span class="stat-text">Coverage</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Referral Flow -->
        <div class="referral-flow animate-on-scroll">
          <h5 class="text-center fw-bold mb-4">Referral Pathway</h5>
          <div class="flow-container">
            <div class="flow-step" v-for="(step, index) in referralSteps" :key="step.title">
              <div class="step-icon" :class="'bg-' + step.color">
                <i :class="step.icon"></i>
              </div>
              <span class="step-title">{{ step.title }}</span>
              <div class="step-arrow" v-if="index < referralSteps.length - 1">
                <i class="bx bx-right-arrow-alt"></i>
              </div>
            </div>
          </div>
          <p class="text-center text-muted mt-4 mb-0">
            <i class="bx bx-info-circle me-2"></i>
            Referral is required for higher-level care. Emergency cases are exempt from this requirement.
          </p>
        </div>
      </div>
    </section>

    <!-- Services Not Covered -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-6 mb-5 mb-lg-0 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon bg-success-soft"><i class="bx bx-check text-success"></i></span>
              <span class="label-text text-success">Included</span>
            </div>
            <h3 class="fw-bold mb-4">Services Covered</h3>
            <div class="coverage-list covered">
              <div class="coverage-item" v-for="item in servicesCovered" :key="item">
                <i class="bx bx-check-circle text-success"></i>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon bg-danger-soft"><i class="bx bx-x text-danger"></i></span>
              <span class="label-text text-danger">Not Covered</span>
            </div>
            <h3 class="fw-bold mb-4">Services Not Covered</h3>
            <div class="coverage-list not-covered">
              <div class="coverage-item" v-for="item in servicesNotCovered" :key="item">
                <i class="bx bx-x-circle text-danger"></i>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How to Access Services -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-directions"></i></span>
            <span class="label-text">Getting Care</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">How to Access Services</h2>
          <p class="lead text-muted">Simple steps to receive healthcare with your PONA HEALTH-X membership</p>
        </div>

        <div class="access-steps">
          <div class="access-step animate-on-scroll" v-for="(step, index) in accessSteps" :key="step.title">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-icon-wrapper">
              <div class="step-icon" :class="'bg-' + step.color">
                <i :class="step.icon"></i>
              </div>
            </div>
            <div class="step-content">
              <h5 class="fw-bold mb-2">{{ step.title }}</h5>
              <p class="text-muted mb-0">{{ step.description }}</p>
            </div>
            <div class="step-connector" v-if="index < accessSteps.length - 1"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Special Programs Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label-light justify-content-center">
            <span class="label-icon"><i class="bx bx-star"></i></span>
            <span class="label-text">Special Programs</span>
          </div>
          <h2 class="display-5 fw-bold mb-3 text-white">Priority Health Programs</h2>
          <p class="lead opacity-75">Special healthcare initiatives for vulnerable populations</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="program in specialPrograms" :key="program.title">
            <div class="program-card h-100">
              <div class="program-icon">
                <i :class="program.icon"></i>
              </div>
              <h5 class="fw-bold mb-3 text-white">{{ program.title }}</h5>
              <p class="opacity-75 mb-4">{{ program.description }}</p>
              <ul class="program-features">
                <li v-for="feature in program.features" :key="feature">
                  <i class="bx bx-check"></i>{{ feature }}
                </li>
              </ul>
              <div class="program-badge">{{ program.badge }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Quality Assurance -->
    <section class="py-5">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-5 mb-lg-0 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-shield-check"></i></span>
              <span class="label-text">Quality</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              Quality
              <span class="text-gradient">Assurance Standards</span>
            </h2>
            <p class="lead text-muted mb-4">
              All PONA HEALTH-X-contracted facilities must meet strict quality standards
              to ensure you receive the best possible care.
            </p>

            <div class="quality-features">
              <div class="quality-item" v-for="item in qualityFeatures" :key="item.title">
                <div class="quality-icon">
                  <i :class="item.icon"></i>
                </div>
                <div class="quality-content">
                  <h6 class="fw-bold mb-1">{{ item.title }}</h6>
                  <p class="text-muted small mb-0">{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="quality-image-container">
              <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600"
                   alt="Quality Healthcare"
                   class="img-fluid rounded-4 main-quality-img">
              <div class="quality-badge">
                <i class="bx bx-check-shield"></i>
                <span>Certified</span>
              </div>
              <div class="quality-stat-card">
                <div class="qs-icon"><i class="bx bx-happy-heart-eyes"></i></div>
                <div class="qs-content">
                  <span class="qs-number">85%</span>
                  <span class="qs-label">Patient Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Digital Services Section -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-mobile-alt"></i></span>
            <span class="label-text">Digital</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Digital Health Services</h2>
          <p class="lead text-muted">Modern technology enhancing your healthcare experience</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="service in digitalServices" :key="service.title">
            <div class="digital-card h-100">
              <div class="digital-icon">
                <i :class="service.icon"></i>
              </div>
              <h5 class="fw-bold mb-3">{{ service.title }}</h5>
              <p class="text-muted mb-3">{{ service.description }}</p>
              <span class="digital-status" :class="service.status">{{ service.statusText }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Find Facility Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="find-facility-card animate-on-scroll">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-4 mb-lg-0">
              <h3 class="fw-bold mb-3">Find a PONA HEALTH-X Facility Near You</h3>
              <p class="text-muted mb-4">
                Locate contracted health facilities in your area. Use our facility finder
                to search by region, county, or district.
              </p>
              <div class="facility-search">
                <div class="row g-3">
                  <div class="col-md-4">
                    <select class="form-select">
                      <option selected>Select Region</option>
                      <option>Central</option>
                      <option>Western</option>
                      <option>Eastern</option>
                      <option>Northern</option>
                      <option>Southern</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <select class="form-select">
                      <option selected>Select County</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <button class="btn btn-primary w-100">
                      <i class="bx bx-search me-2"></i>Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="facility-stats-grid">
                <div class="facility-stat" v-for="stat in facilityStats" :key="stat.label">
                  <div class="fs-icon" :class="'bg-' + stat.color">
                    <i :class="stat.icon"></i>
                  </div>
                  <div class="fs-content">
                    <span class="fs-number">{{ stat.value }}</span>
                    <span class="fs-label">{{ stat.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-help-circle"></i></span>
            <span class="label-text">FAQs</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Common Questions About Services</h2>
          <p class="lead text-muted">Answers to frequently asked questions about PONA HEALTH-X services</p>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="accordion" id="servicesFAQ">
              <div class="accordion-item animate-on-scroll" v-for="(faq, index) in faqs" :key="index">
                <h2 class="accordion-header">
                  <button class="accordion-button" :class="{ collapsed: index !== 0 }"
                          type="button" data-bs-toggle="collapse"
                          :data-bs-target="'#faq' + index">
                    <i class="bx bx-help-circle me-3 text-primary"></i>
                    {{ faq.question }}
                  </button>
                </h2>
                <div :id="'faq' + index"
                     class="accordion-collapse collapse"
                     :class="{ show: index === 0 }"
                     data-bs-parent="#servicesFAQ">
                  <div class="accordion-body">{{ faq.answer }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-8 animate-on-scroll">
            <h2 class="display-5 fw-bold mb-3 text-white">Ready to Access Quality Healthcare?</h2>
            <p class="lead mb-4 mb-lg-0 opacity-75">
              Join PONA HEALTH-X today and start enjoying comprehensive healthcare services for you and your family.
              Our network of facilities is ready to serve you.
            </p>
          </div>
          <div class="col-lg-4 text-lg-end animate-on-scroll">
            <router-link to="/enrollment" class="btn btn-light btn-lg mb-3 me-3">
              <i class="bx bx-user-plus me-2"></i>Enroll Now
            </router-link>
            <router-link to="/contact" class="btn btn-outline-light btn-lg mb-3">
              <i class="bx bx-phone me-2"></i>Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3" style="background: white; padding: 5px; border-radius: 8px;">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small text-white-50">Community-Based Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Providing quality healthcare services to all through community-based health insurance.
            </p>
            <div class="social-links">
              <a href="#" class="social-link"><i class="bx bxl-facebook-circle"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-linkedin-square"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-youtube"></i></a>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/benefits">Benefits</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="footer-links">
              <li><a href="#">FAQs</a></li>
              <li><a href="#">Downloads</a></li>
              <li><router-link to="/enrollment">Enrollment</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="col-lg-4">
            <h6 class="fw-bold mb-3 text-white">Contact Us</h6>
            <ul class="footer-contact">
              <li><i class="bx bx-map me-2"></i>Headquarters</li>
              <li><i class="bx bx-phone me-2"></i>Call: +254 700 000 000</li>
              <li><i class="bx bx-envelope me-2"></i>info@ponahealth.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4 opacity-25">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white-50 small text-decoration-none me-3">Privacy Policy</a>
            <a href="#" class="text-white-50 small text-decoration-none">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthServicesPage',

  data() {
    return {
      showScrollTop: false,
      activeCategory: 0,

      servicesPreview: [
        { icon: 'bx bx-clinic', title: 'Outpatient Care', count: '12 Services', gradient: 'linear-gradient(135deg, #2c5aa0, #4a90e2)' },
        { icon: 'bx bx-bed', title: 'Inpatient Care', count: '8 Services', gradient: 'linear-gradient(135deg, #28a745, #5cb85c)' },
        { icon: 'bx bx-first-aid', title: 'Emergency', count: '6 Services', gradient: 'linear-gradient(135deg, #dc3545, #f1707a)' },
        { icon: 'bx bx-heart', title: 'Maternity', count: '10 Services', gradient: 'linear-gradient(135deg, #e83e8c, #f8a5c2)' },
        { icon: 'bx bx-test-tube', title: 'Laboratory', count: '15 Services', gradient: 'linear-gradient(135deg, #17a2b8, #5bc0de)' },
        { icon: 'bx bx-capsule', title: 'Pharmacy', count: '100+ Medicines', gradient: 'linear-gradient(135deg, #6f42c1, #9d7bd1)' }
      ],

      serviceCategories: [
        {
          icon: 'bx bx-clinic',
          title: 'Outpatient Services',
          description: 'Primary healthcare and consultations without hospital admission',
          gradient: 'linear-gradient(135deg, #2c5aa0, #4a90e2)',
          services: [
            { name: 'General medical consultations', note: 'Unlimited visits' },
            { name: 'Physical examinations', note: null },
            { name: 'Diagnosis and treatment', note: null },
            { name: 'Health education and counseling', note: null },
            { name: 'Vaccination and immunization', note: 'As per national schedule' },
            { name: 'Growth monitoring', note: 'For children under 5' },
            { name: 'Minor surgical procedures', note: null },
            { name: 'Wound care and dressing', note: null },
            { name: 'Injections and infusions', note: null },
            { name: 'Chronic disease management', note: 'Diabetes, hypertension, etc.' },
            { name: 'Mental health consultations', note: 'Basic services' },
            { name: 'Nutritional assessment', note: null }
          ],
          note: 'Visit your designated health center for outpatient services. No appointment required.'
        },
        {
          icon: 'bx bx-bed',
          title: 'Inpatient Services',
          description: 'Hospital admission and overnight care',
          gradient: 'linear-gradient(135deg, #28a745, #5cb85c)',
          services: [
            { name: 'Hospital admission', note: 'When medically necessary' },
            { name: 'Room and board', note: 'Standard ward' },
            { name: 'Nursing care', note: '24/7 care' },
            { name: 'Medical treatment', note: null },
            { name: 'Surgical procedures', note: 'Covered surgeries' },
            { name: 'Post-operative care', note: null },
            { name: 'Intensive care (ICU)', note: 'When available' },
            { name: 'Discharge planning', note: null }
          ],
          note: 'Referral may be required for hospital admission. Emergency cases are exempt.'
        },
        {
          icon: 'bx bx-first-aid',
          title: 'Emergency Services',
          description: 'Urgent and life-threatening medical conditions',
          gradient: 'linear-gradient(135deg, #dc3545, #f1707a)',
          services: [
            { name: 'Emergency consultations', note: '24/7 availability' },
            { name: 'Trauma care', note: null },
            { name: 'Emergency surgery', note: null },
            { name: 'Resuscitation', note: null },
            { name: 'Stabilization', note: null },
            { name: 'Ambulance services', note: 'Where available' }
          ],
          note: 'Emergency services are available at any PONA HEALTH-X facility without referral requirement.'
        },
        {
          icon: 'bx bx-heart',
          title: 'Maternal & Child Health',
          description: 'Comprehensive care for mothers and children',
          gradient: 'linear-gradient(135deg, #e83e8c, #f8a5c2)',
          services: [
            { name: 'Antenatal care (ANC)', note: 'All 8 visits covered' },
            { name: 'Delivery services', note: 'Normal & assisted' },
            { name: 'Cesarean section', note: 'When medically indicated' },
            { name: 'Postnatal care (PNC)', note: null },
            { name: 'Newborn care', note: null },
            { name: 'Family planning', note: 'All methods' },
            { name: 'Prevention of mother-to-child transmission (PMTCT)', note: null },
            { name: 'Child immunization', note: 'Full schedule' },
            { name: 'Growth monitoring', note: null },
            { name: 'Integrated management of childhood illness (IMCI)', note: null }
          ],
          note: 'Maternal services are a priority. Pregnant women should register early for ANC.'
        },
        {
          icon: 'bx bx-test-tube',
          title: 'Laboratory Services',
          description: 'Diagnostic tests and investigations',
          gradient: 'linear-gradient(135deg, #17a2b8, #5bc0de)',
          services: [
            { name: 'Complete blood count (CBC)', note: null },
            { name: 'Blood glucose testing', note: null },
            { name: 'Urinalysis', note: null },
            { name: 'Stool examination', note: null },
            { name: 'Malaria testing', note: null },
            { name: 'HIV testing', note: 'With counseling' },
            { name: 'Hepatitis B & C screening', note: null },
            { name: 'Pregnancy tests', note: null },
            { name: 'TB testing', note: 'Sputum examination' },
            { name: 'Basic biochemistry', note: null },
            { name: 'Blood grouping', note: null },
            { name: 'Microscopy', note: null },
            { name: 'Culture and sensitivity', note: 'Where available' },
            { name: 'Lipid profile', note: null },
            { name: 'Kidney function tests', note: null }
          ],
          note: 'Laboratory tests are ordered by healthcare providers based on clinical need.'
        },
        {
          icon: 'bx bx-scan',
          title: 'Imaging Services',
          description: 'Diagnostic imaging and radiology',
          gradient: 'linear-gradient(135deg, #ffc107, #ffda6a)',
          services: [
            { name: 'X-ray', note: 'Chest, limbs, abdomen' },
            { name: 'Ultrasound', note: 'Abdominal, obstetric' },
            { name: 'Basic radiology', note: null },
            { name: 'ECG/EKG', note: 'Where available' }
          ],
          note: 'Advanced imaging like CT and MRI may require referral and co-payment.'
        },
        {
          icon: 'bx bx-capsule',
          title: 'Pharmacy Services',
          description: 'Essential medicines and prescriptions',
          gradient: 'linear-gradient(135deg, #6f42c1, #9d7bd1)',
          services: [
            { name: 'Essential medicines', note: 'Per national list' },
            { name: 'Antibiotics', note: null },
            { name: 'Pain relievers', note: null },
            { name: 'Anti-malarials', note: null },
            { name: 'Chronic disease medications', note: 'Diabetes, hypertension' },
            { name: 'Vitamins and supplements', note: 'As prescribed' },
            { name: 'ORS and zinc', note: 'For diarrhea' },
            { name: 'Contraceptives', note: 'All methods' }
          ],
          note: 'Medicines are dispensed based on the National Essential Medicines List.'
        },
        {
          icon: 'bx bx-happy-beaming',
          title: 'Dental Services',
          description: 'Basic oral healthcare',
          gradient: 'linear-gradient(135deg, #fd7e14, #ffb347)',
          services: [
            { name: 'Dental consultation', note: null },
            { name: 'Tooth extraction', note: 'Simple extractions' },
            { name: 'Dental abscess treatment', note: null },
            { name: 'Oral pain management', note: null },
            { name: 'Basic dental hygiene', note: null }
          ],
          note: 'Advanced dental procedures like root canal and orthodontics are not covered.'
        }
      ],

      facilityLevels: [
        {
          icon: 'bx bx-home-heart',
          title: 'Health Posts',
          description: 'Community-level primary care serving 3,000-5,000 people',
          color: 'info',
          services: ['Preventive care', 'Health education', 'Basic treatment', 'Referrals'],
          count: '16,000+',
          coverage: 'Community'
        },
        {
          icon: 'bx bx-plus-medical',
          title: 'Health Centers',
          description: 'Primary healthcare facility serving 15,000-25,000 people',
          color: 'success',
          services: ['Outpatient care', 'Maternal care', 'Laboratory', 'Pharmacy'],
          count: '3,500+',
          coverage: 'District'
        },
        {
          icon: 'bx bx-building',
          title: 'Primary Hospitals',
          description: 'District-level hospital serving 60,000-100,000 people',
          color: 'warning',
          services: ['Inpatient care', 'Surgery', 'Emergency', 'Specialists'],
          count: '200+',
          coverage: 'District'
        },
        {
          icon: 'bx bx-hospital',
          title: 'General Hospitals',
          description: 'Referral hospitals with specialized services',
          color: 'primary',
          services: ['Specialized care', 'Advanced surgery', 'ICU', 'Imaging'],
          count: '100+',
          coverage: 'Regional'
        }
      ],

      referralSteps: [
        { icon: 'bx bx-home-heart', title: 'Health Post', color: 'info' },
        { icon: 'bx bx-plus-medical', title: 'Health Center', color: 'success' },
        { icon: 'bx bx-building', title: 'Primary Hospital', color: 'warning' },
        { icon: 'bx bx-hospital', title: 'General Hospital', color: 'primary' }
      ],

      servicesCovered: [
        'Outpatient consultations and treatment',
        'Inpatient hospital care',
        'Emergency medical services',
        'Maternal and child health services',
        'Laboratory tests and diagnostics',
        'Essential medicines and prescriptions',
        'Basic imaging (X-ray, Ultrasound)',
        'Minor and major surgical procedures',
        'Chronic disease management',
        'Mental health services (basic)',
        'Dental care (basic)',
        'Rehabilitation services (basic)'
      ],

      servicesNotCovered: [
        'Cosmetic and plastic surgery',
        'Fertility treatments (IVF)',
        'Treatment outside the country',
        'Experimental treatments',
        'Non-essential dental (braces, whitening)',
        'Services at non-contracted facilities',
        'Self-inflicted injuries',
        'Injuries from illegal activities',
        'Traditional medicine (most)',
        'Hearing aids and glasses',
        'Private room upgrades',
        'Accompanying person costs'
      ],

      accessSteps: [
        {
          icon: 'bx bx-id-card',
          title: 'Present Your PONA HEALTH-X Card',
          description: 'Show your valid PONA HEALTH-X membership card at the facility reception',
          color: 'primary'
        },
        {
          icon: 'bx bx-check-circle',
          title: 'Verify Membership',
          description: 'Staff will verify your membership status and coverage',
          color: 'info'
        },
        {
          icon: 'bx bx-user-voice',
          title: 'Consult Healthcare Provider',
          description: 'See the doctor or healthcare worker for your health concern',
          color: 'success'
        },
        {
          icon: 'bx bx-first-aid',
          title: 'Receive Treatment',
          description: 'Get the necessary treatment, tests, or medications',
          color: 'warning'
        },
        {
          icon: 'bx bx-log-out-circle',
          title: 'Checkout',
          description: 'Complete your visit with minimal or no out-of-pocket payment',
          color: 'purple'
        }
      ],

      specialPrograms: [
        {
          icon: 'bx bx-female',
          title: 'Safe Motherhood',
          description: 'Comprehensive maternal healthcare to ensure safe pregnancy and delivery',
          features: ['Free ANC visits', 'Skilled birth attendance', 'Emergency obstetric care', 'Postnatal support'],
          badge: 'Priority'
        },
        {
          icon: 'bx bx-child',
          title: 'Child Health',
          description: 'Integrated services for children under 5 years of age',
          features: ['Immunization', 'Nutrition support', 'Growth monitoring', 'IMCI services'],
          badge: 'Essential'
        },
        {
          icon: 'bx bx-plus-medical',
          title: 'Chronic Disease Care',
          description: 'Long-term management of non-communicable diseases',
          features: ['Diabetes care', 'Hypertension management', 'Regular monitoring', 'Medication supply'],
          badge: 'Ongoing'
        },
        {
          icon: 'bx bx-shield-check',
          title: 'Infectious Disease',
          description: 'Prevention and treatment of major infectious diseases',
          features: ['HIV/AIDS services', 'TB treatment', 'Malaria care', 'Hepatitis screening'],
          badge: 'Free'
        },
        {
          icon: 'bx bx-brain',
          title: 'Mental Health',
          description: 'Basic mental health services integrated into primary care',
          features: ['Counseling', 'Depression treatment', 'Anxiety management', 'Referral support'],
          badge: 'Expanding'
        },
        {
          icon: 'bx bx-handicap',
          title: 'Disability Support',
          description: 'Services for persons with disabilities',
          features: ['Assistive devices', 'Rehabilitation', 'Specialized care', 'Support services'],
          badge: 'Inclusive'
        }
      ],

      qualityFeatures: [
        {
          icon: 'bx bx-certification',
          title: 'Accredited Facilities',
          description: 'All contracted facilities meet quality standards'
        },
        {
          icon: 'bx bx-user-check',
          title: 'Qualified Staff',
          description: 'Licensed healthcare professionals with regular training'
        },
        {
          icon: 'bx bx-search-alt',
          title: 'Regular Monitoring',
          description: 'Ongoing quality assessments and improvement programs'
        },
        {
          icon: 'bx bx-message-rounded-check',
          title: 'Patient Feedback',
          description: 'Member satisfaction surveys and complaint resolution'
        }
      ],

      digitalServices: [
        {
          icon: 'bx bx-mobile-alt',
          title: 'Member Portal',
          description: 'Access your account, view coverage, and manage beneficiaries online',
          status: 'active',
          statusText: 'Available'
        },
        {
          icon: 'bx bx-id-card',
          title: 'Digital Card',
          description: 'Download your digital PONA HEALTH-X card for easy access at facilities',
          status: 'active',
          statusText: 'Available'
        },
        {
          icon: 'bx bx-credit-card',
          title: 'Online Payment',
          description: 'Pay premiums online via bank transfer or M-Pesa',
          status: 'active',
          statusText: 'Available'
        },
        {
          icon: 'bx bx-video',
          title: 'Telemedicine',
          description: 'Virtual consultations with healthcare providers',
          status: 'coming',
          statusText: 'Coming Soon'
        }
      ],

      facilityStats: [
        { icon: 'bx bx-clinic', value: '16,000+', label: 'Health Posts', color: 'info' },
        { icon: 'bx bx-plus-medical', value: '3,500+', label: 'Health Centers', color: 'success' },
        { icon: 'bx bx-hospital', value: '311+', label: 'Hospitals', color: 'primary' },
        { icon: 'bx bx-map', value: '47', label: 'Counties', color: 'warning' }
      ],

      faqs: [
        {
          question: 'Can I visit any health facility with my PONA HEALTH-X card?',
          answer: 'You can visit any PONA HEALTH-X-contracted health facility. For primary care, you should first visit your designated health center. Referral to higher-level facilities requires authorization from your primary healthcare provider, except for emergencies.'
        },
        {
          question: 'What should I bring when visiting a health facility?',
          answer: 'Bring your valid PONA HEALTH-X membership card and a form of identification. If you have been referred, bring your referral letter. For follow-up visits, bring any previous prescriptions or medical records.'
        },
        {
          question: 'Are all medicines covered by PONA HEALTH-X?',
          answer: 'PONA HEALTH-X covers medicines on the National Essential Medicines List. If a prescribed medicine is not on the list, you may need to pay out-of-pocket. Generic alternatives are usually available and covered.'
        },
        {
          question: 'How do I get a referral to a specialist?',
          answer: 'Visit your primary healthcare facility (health center) first. If specialized care is needed, the healthcare provider will issue a referral letter. Present this letter at the referral hospital to access specialist services.'
        },
        {
          question: 'What if I need care while traveling to another region?',
          answer: 'In emergencies, you can receive care at any PONA HEALTH-X facility nationwide. For planned care, it\'s best to get treatment in your enrolled district. Contact your district health office for guidance on accessing care while traveling.'
        },
        {
          question: 'Are there any services that require co-payment?',
          answer: 'Most essential services are fully covered. However, some advanced services like CT scans, MRI, or specialized procedures may require co-payment. Your healthcare provider will inform you of any costs before treatment.'
        }
      ]
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    toggleCategory(index) {
      this.activeCategory = this.activeCategory === index ? -1 : index;
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    goToMemberLogin() {
      this.$router.push('/member-login');
    },

    goToStaffLogin() {
      this.$router.push('/login');
    },
    goToPage(page) {
      this.$router.push(page);
    },

  }
};
</script>

<style scoped>
/* ========================================================================= */
/* SERVICES PAGE - PONA HEALTH-X STYLES */
/* ========================================================================= */

.services-page {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

/* ========================================================================= */
/* NAVIGATION */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s ease;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #2c5aa0 !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(5px);
}

/* ========================================================================= */
/* PAGE HEADER */
/* ========================================================================= */
.page-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  padding-top: 120px;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
}

.header-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse"><circle cx="30" cy="30" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)"/></svg>');
}

.header-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
}

.z-2 { z-index: 2; }
.min-vh-50 { min-height: 50vh; }

.breadcrumb-light {
  background: transparent;
  margin: 0;
  padding: 0;
}

.breadcrumb-light .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.breadcrumb-light .breadcrumb-item a:hover { color: white; }
.breadcrumb-light .breadcrumb-item.active { color: white; }
.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before { color: rgba(255, 255, 255, 0.5); }

.header-features { margin-top: 1.5rem; }

.header-feature {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
}

.header-feature i { color: #4ade80; }

.header-image-stack {
  position: relative;
  height: 350px;
}

.stack-item {
  position: absolute;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease;
}

.stack-item img {
  width: 180px;
  height: 140px;
  object-fit: cover;
}

.stack-1 { top: 0; left: 20%; transform: rotate(-5deg); z-index: 3; }
.stack-2 { top: 80px; right: 10%; transform: rotate(5deg); z-index: 2; }
.stack-3 { bottom: 20px; left: 30%; transform: rotate(-3deg); z-index: 1; }
.stack-item:hover { transform: rotate(0deg) scale(1.1); z-index: 10; }

.stack-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.badge-number {
  display: block;
  font-size: 2rem;
  font-weight: 900;
  color: #2c5aa0;
  line-height: 1;
}

.badge-text {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 600;
}

/* ========================================================================= */
/* SECTION LABELS */
/* ========================================================================= */
.section-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.section-label-light {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.label-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c5aa0;
}

.section-label-light .label-icon {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.label-text {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2c5aa0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-label-light .label-text { color: rgba(255, 255, 255, 0.9); }

.text-gradient {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.bg-success-soft { background: #d4edda !important; }
.bg-danger-soft { background: #f8d7da !important; }

/* ========================================================================= */
/* OVERVIEW STATS */
/* ========================================================================= */
.overview-stats {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.stat-item { text-align: center; }

.stat-circle {
  width: 100px;
  height: 100px;
  position: relative;
  margin-bottom: 0.5rem;
}

.stat-circle svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.bg-circle { fill: none; stroke: #e9ecef; stroke-width: 8; }

.progress-circle {
  fill: none;
  stroke: #2c5aa0;
  stroke-width: 8;
  stroke-linecap: round;
  stroke-dasharray: 283;
  transition: stroke-dashoffset 1s ease;
}

.stat-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  font-weight: 900;
  color: #2c5aa0;
}

.stat-label { font-size: 0.85rem; color: #6c757d; font-weight: 600; }

/* ========================================================================= */
/* SERVICES PREVIEW GRID */
/* ========================================================================= */
.services-preview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
}

.preview-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.preview-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
}

.preview-icon {
  width: 55px;
  height: 55px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.preview-content h6 { margin-bottom: 0.25rem; }

/* ========================================================================= */
/* SERVICES ACCORDION */
/* ========================================================================= */
.services-accordion {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.service-category {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  cursor: pointer;
}

.service-category:hover { box-shadow: 0 10px 40px rgba(44, 90, 160, 0.15); }
.service-category.active { box-shadow: 0 15px 50px rgba(44, 90, 160, 0.2); }

.category-header {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
  transition: all 0.3s ease;
}

.service-category:hover .category-header { background: #f8f9fa; }

.category-icon {
  width: 60px;
  height: 60px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: white;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.service-category:hover .category-icon { transform: scale(1.1); }

.category-info { flex: 1; }

.category-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.service-count {
  background: #e3f2fd;
  color: #2c5aa0;
  padding: 0.35rem 1rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 700;
}

.toggle-icon {
  font-size: 1.5rem;
  color: #6c757d;
  transition: transform 0.3s ease;
}

.service-category.active .toggle-icon { transform: rotate(180deg); }

.category-body {
  padding: 0 2rem 2rem 2rem;
  border-top: 1px solid #f0f0f0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  padding-top: 1.5rem;
}

.service-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
}

.service-item:hover { background: #f8f9fa; }
.service-item i { font-size: 1.25rem; margin-top: 2px; flex-shrink: 0; }
.service-name { display: block; font-weight: 600; color: #1e3f70; }
.service-note { display: block; font-size: 0.8rem; color: #6c757d; }

.category-footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.75rem;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #6c757d;
}

.category-footer i { color: #2c5aa0; font-size: 1.25rem; }

/* ========================================================================= */
/* FACILITY LEVELS */
/* ========================================================================= */
.facility-levels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
}

.level-card {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  position: relative;
  text-align: center;
}

.level-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.level-number {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 35px;
  height: 35px;
  background: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #6c757d;
}

.level-icon {
  width: 70px;
  height: 70px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.level-card:hover .level-icon { transform: scale(1.1) rotate(5deg); }

.bg-primary { background: linear-gradient(135deg, #2c5aa0, #4a90e2) !important; }
.bg-success { background: linear-gradient(135deg, #28a745, #5cb85c) !important; }
.bg-warning { background: linear-gradient(135deg, #ffc107, #ffda6a) !important; }
.bg-info { background: linear-gradient(135deg, #17a2b8, #5bc0de) !important; }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #9d7bd1) !important; }

.level-services {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
  text-align: left;
}

.level-services li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #495057;
}

.level-services li i { color: #28a745; }

.level-stats {
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
}

.level-stat { text-align: center; }
.stat-num { display: block; font-size: 1.25rem; font-weight: 900; color: #2c5aa0; }
.stat-text { font-size: 0.8rem; color: #6c757d; }

.referral-flow {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  margin-top: 3rem;
}

.flow-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.flow-step {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.step-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.step-title { font-weight: 600; color: #1e3f70; }
.step-arrow { font-size: 1.5rem; color: #6c757d; margin-left: 0.5rem; }

/* ========================================================================= */
/* COVERAGE LISTS */
/* ========================================================================= */
.coverage-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.coverage-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: white;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
}

.coverage-item:hover { transform: translateX(10px); }
.covered .coverage-item:hover { background: #d4edda; }
.not-covered .coverage-item:hover { background: #f8d7da; }
.coverage-item i { font-size: 1.25rem; flex-shrink: 0; }

/* ========================================================================= */
/* ACCESS STEPS */
/* ========================================================================= */
.access-steps {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 700px;
  margin: 0 auto;
}

.access-step {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  position: relative;
  padding-bottom: 2rem;
}

.step-number {
  position: absolute;
  left: 25px;
  top: 0;
  width: 30px;
  height: 30px;
  background: #e3f2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #2c5aa0;
  font-size: 0.85rem;
  z-index: 2;
}

.step-icon-wrapper { position: relative; z-index: 1; }

.step-icon {
  width: 80px;
  height: 80px;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.access-step:hover .step-icon { transform: scale(1.1); }
.step-content { flex: 1; padding-top: 1rem; }

.step-connector {
  position: absolute;
  left: 39px;
  top: 80px;
  width: 3px;
  height: calc(100% - 60px);
  background: linear-gradient(180deg, #2c5aa0, #e3f2fd);
  border-radius: 2px;
}

/* ========================================================================= */
/* SPECIAL PROGRAMS */
/* ========================================================================= */
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
}

.program-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: all 0.4s ease;
  position: relative;
}

.program-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-10px);
  border-color: rgba(255, 255, 255, 0.3);
}

.program-icon {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.program-card:hover .program-icon { transform: scale(1.1) rotate(5deg); }

.program-features { list-style: none; padding: 0; margin: 0; }

.program-features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
}

.program-features li i { color: #4ade80; }

.program-badge {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.35rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
}

/* ========================================================================= */
/* QUALITY SECTION */
/* ========================================================================= */
.quality-features {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.quality-item {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.quality-item:hover {
  background: #e3f2fd;
  transform: translateX(10px);
}

.quality-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.quality-image-container { position: relative; }
.main-quality-img { box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15); }

.quality-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  background: linear-gradient(135deg, #28a745, #5cb85c);
  color: white;
  padding: 0.75rem 1.25rem;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
}

.quality-stat-card {
  position: absolute;
  bottom: -20px;
  right: 20px;
  background: white;
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.qs-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #ffc107, #ffda6a);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.qs-number { display: block; font-size: 1.5rem; font-weight: 900; color: #1e3f70; line-height: 1; }
.qs-label { font-size: 0.8rem; color: #6c757d; }

/* ========================================================================= */
/* DIGITAL SERVICES */
/* ========================================================================= */
.digital-card {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  text-align: center;
}

.digital-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.digital-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.digital-card:hover .digital-icon {
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  color: white;
  transform: scale(1.1);
}

.digital-status {
  display: inline-block;
  padding: 0.35rem 1rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 700;
}

.digital-status.active { background: #d4edda; color: #28a745; }
.digital-status.coming { background: #fff3cd; color: #856404; }

/* ========================================================================= */
/* FIND FACILITY */
/* ========================================================================= */
.find-facility-card {
  background: white;
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  border: 3px solid #e3f2fd;
}

.facility-search .form-select {
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 0.75rem;
  font-weight: 500;
}

.facility-search .form-select:focus {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 0.2rem rgba(44, 90, 160, 0.15);
}

.facility-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.facility-stat {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.facility-stat:hover {
  background: #e3f2fd;
  transform: translateY(-3px);
}

.fs-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.fs-number { display: block; font-size: 1.25rem; font-weight: 900; color: #1e3f70; line-height: 1; }
.fs-label { font-size: 0.85rem; color: #6c757d; }

/* ========================================================================= */
/* FAQ ACCORDION */
/* ========================================================================= */
.accordion-item {
  margin-bottom: 1rem;
  border: none;
  border-radius: 1rem !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.accordion-button {
  font-weight: 600;
  color: #1e3f70;
  background-color: white;
  padding: 1.25rem 1.5rem;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1e3f70;
  box-shadow: none;
}

.accordion-button:focus { box-shadow: none; }
.accordion-body { padding: 1.5rem; line-height: 1.8; color: #495057; }

/* ========================================================================= */
/* BUTTONS */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  color: white;
}

.btn-primary:hover { background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%); }
.btn-outline-primary { color: #2c5aa0; border-color: #2c5aa0; }
.btn-outline-primary:hover { background: #2c5aa0; color: white; }
.btn-light { background: white; color: #2c5aa0; }
.btn-outline-light { color: white; border-color: white; }
.btn-outline-light:hover { background: white; color: #2c5aa0; }

/* ========================================================================= */
/* FOOTER */
/* ========================================================================= */
footer { background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%); }
.footer-links { list-style: none; padding: 0; }
.footer-links li { margin-bottom: 0.5rem; }

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover { color: white; padding-left: 8px; }
.footer-contact { list-style: none; padding: 0; }

.footer-contact li {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.social-links { display: flex; gap: 1rem; }

.social-links .social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-links .social-link:hover {
  background: white;
  color: #2c5aa0;
  transform: translateY(-5px);
}

/* ========================================================================= */
/* SCROLL BUTTON */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 992px) {
  .services-preview-grid { grid-template-columns: repeat(2, 1fr); }
  .overview-stats { justify-content: center; }
  .flow-container { flex-direction: column; }
  .step-arrow { transform: rotate(90deg); margin: 0.5rem 0; }
  .access-steps { padding-left: 1rem; }
}

@media (max-width: 768px) {
  .page-header { padding-top: 100px; }
  .page-header h1 { font-size: 2.5rem; }
  .header-features { flex-direction: column; }
  .services-preview-grid { grid-template-columns: 1fr; }
  .category-header { flex-wrap: wrap; }
  .category-meta { width: 100%; justify-content: space-between; margin-top: 1rem; }
  .facility-stats-grid { grid-template-columns: 1fr; }
  .find-facility-card { padding: 2rem; }
}

/* ========================================================================= */
/* UTILITY */
/* ========================================================================= */
.text-white-50 { color: rgba(255, 255, 255, 0.5) !important; }
</style>